import { HeadingItem } from 'components';
import { TripContext } from 'contexts';
import dateFormat from "dateformat";
import React, { FC, useContext } from 'react';
import { Signature } from 'services/types';
import './item-signature-recap.scss';

type Props = {
    signatureId: number
}

export const ItemSignatureRecap: FC<Props> = ({ signatureId }) => {

    const tripContext = useContext(TripContext)
    const signature: Signature = tripContext.signatures.find(sign => sign.id === signatureId) ?? {} as Signature

    return (
        <div className={'card-material'} style={{ margin: '5px' }}>
            <HeadingItem text={`Receiver's Signature`} />
            <div className={'signature-recap-box'}>
                <div className={'signature-recap-title'}>Name</div>
                <div className={'signature-recap-colon'}>:</div>
                <div className={'signature-recap-value'}>{signature.receiverName}</div>
            </div>
            <div className={'signature-recap-box'}>
                <div className={'signature-recap-title'}>Date</div>
                <div className={'signature-recap-colon'}>:</div>
                <div className={'signature-recap-value'}> {signature.signedTime && dateFormat(signature.signedTime, 'mm/dd/yy HH:MM')}</div>
            </div>
            <div className={'signature-recap-box'}>
                <div className={'signature-recap-title'}>Signature</div>
                <div className={'signature-recap-colon'}>:</div>
                <div className={'signature-recap-value'}><img src={signature.signatureImage!} alt={'signature'} height={50} width={150} /></div>
            </div>
        </div>
    )
}

